import { ActionIcon } from '@mantine/core'

export default ActionIcon.extend({
  defaultProps: {
    radius: 'xl',
    size: 'lg',
    variant: 'filled'
  },
})
